import React from 'react'

import { IconParkComponent } from './IconParkComponent'
import { iconParkMap, IconParkSVGWrapperProps } from './types'

/**
 * iconPark图标组件
 *
 * @param props - 参数
 * @param props.name - 图标名称
 * @param props.color - 图标颜色
 * @param props.hoverColor - hover时图标颜色
 * @param props.text - 图标后文本
 * @param props.size - 图标尺寸
 * @param props.width - 图标宽度
 * @param props.height - 图标高度
 * @param props.spin - 是否旋转
 * @param props.rtl - 是否左右翻转
 * @param props.fill - 图标填充色
 * @param props.stroke - 图标描边
 * @returns React.ReactNode
 */
export const GrowpIcon: React.FC<IconParkSVGWrapperProps> = (props) => {
  if (!iconParkMap[props.name]) {
    console.error(`未找到图标 ${props.name}`)
    return null
  }

  return <IconParkComponent {...props} />
}
